import { Component, Input, OnInit } from '@angular/core';
import { Review } from '@app/models/performance/review.model';
import { AuthService, NotifyService } from '@app/services';

@Component({
    selector: 'app-review-note',
    templateUrl: './review-note.template.html',
    styleUrls: ['./review-note.style.scss'],
})
export class ReviewNoteComponent implements OnInit {
    @Input() review: Review;

    noteDialogIsOpen = false;
    userHasNoteModificationPermission = false;

    constructor(
        public auth: AuthService,
        private notify: NotifyService
    ) {}

    async ngOnInit(): Promise<void> {
        this.setModificationPermission();
    }

    private setModificationPermission(): void {
        if (!this.auth.employee) {
            this.userHasNoteModificationPermission = false;
            return;
        }

        this.userHasNoteModificationPermission =
            this.auth.isAdmin() || this.auth.canAccessEmployee(this.review.subject);
    }

    saveNote(): void {
        this.review
            .save()
            .then(() => {
                this.notify.success('performance.show.reviewNoteSaved');
            })
            .catch((err) => {
                this.notify.error(err.message || 'performance.show.couldNotSaveReviewNote');
            })
            .finally(() => {
                this.noteDialogIsOpen = false;
            });
    }

    addNote(): void {
        this.noteDialogIsOpen = true;
    }
}
